module.exports = __webpack_public_path__ + "img/p1-info.9ec586ef.jpg";